import { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Toast,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import img12 from "../assets/bgimg.png";

export default function ResetPassword() {
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState({
    show: false,
    message: "",
    bg: "danger",
  });

  /* Validation */
  const validate = () => {
    const newErrors = {};

    if (!password) {
      newErrors.password = "Please enter new password";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Please confirm password";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* Submit */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    setToast({
      show: true,
      message: "Password reset successfully",
      bg: "success",
    });

    setTimeout(() => {
      navigate("/");
    }, 1200);
  };

  return (
    <>

      <Toast
        show={toast.show}
        onClose={() => setToast({ ...toast, show: false })}
        delay={3000}
        autohide
        bg={toast.bg}
        style={{
          position: "fixed",
          top: 20,
          right: 20,
          zIndex: 2000,
        }}
      >
        <Toast.Body className="text-white">
          {toast.message}
        </Toast.Body>
      </Toast>

      {/*  --- >Background */}
      <div
        style={{
          minHeight: "100vh",
          backgroundImage: `url(${img12})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          style={{
            minHeight: "100vh",
            backdropFilter: "blur(6px)",
            backgroundColor: "rgba(0,0,0,0.25)",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col xl={4} lg={5} md={6} sm={10} xs={12}>
                <Card className="resetcard shadow-lg">
                  <Card.Body className="p-4 resetcard-body text-white">

                    <h4 className="fw-bold text-center mb-2">
                      Reset Password
                    </h4>

                    <p className="text-center mb-4 opacity-75">
                      Create a new password for your account
                    </p>

                    <Form onSubmit={handleSubmit}>

                      {/* New Password */}
                      <Form.Group className="mb-3">
                        <Form.Label>New Password</Form.Label>

                        <div className="position-relative">
                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter new password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="py-2 reset-input"
                          />

                          <span
                            className="position-absolute top-50 end-0 translate-middle-y me-3"
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? (
                              <FaEye style={{ color: "#f4c430" }} />
                            ) : (
                              <FaEyeSlash style={{ color: "#2d0c57" }} />
                            )}
                          </span>
                        </div>

                        {errors.password && (
                          <small className="text-danger">
                            {errors.password}
                          </small>
                        )}
                      </Form.Group>

                      {/* Confirm Password */}
                      <Form.Group className="mb-2">
                        <Form.Label>Confirm Password</Form.Label>

                        <div className="position-relative">
                          <Form.Control
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="py-2 reset-input"
                          />

                          <span
                            className="position-absolute top-50 end-0 translate-middle-y me-3"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                          >
                            {showConfirmPassword ? (
                              <FaEye style={{ color: "#f4c430" }} />
                            ) : (
                              <FaEyeSlash style={{ color: "#2d0c57" }} />
                            )}
                          </span>
                        </div>

                        {errors.confirmPassword && (
                          <small className="text-danger">
                            {errors.confirmPassword}
                          </small>
                        )}
                      </Form.Group>

                      <div className="d-flex justify-content-end mb-3">
                        <Button
                          variant="link"
                          className="p-0 text-decoration-none"
                          style={{ color: "#2d0c57" }}
                          onClick={() => navigate("/")}
                        >
                          Verify password?
                        </Button>
                      </div>

                      <div className="d-flex justify-content-center align-items-center">
                        <button
                          type="submit"
                          className="w-100 submit-btn p-2 reset-btn"
                        >
                          Reset Password
                        </button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}
